import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { LayoutService } from '@dss-libs/portal/utility/portal-utility-services';
import { PaymentPlansComponent, SidebarComponent } from '@dss-libs/portal/feature/portal-core-features';
import { RouterOutlet } from '@angular/router';
import { AutoHideScrollbarDirective } from '@dss-libs/shared/ui/common-directives';

@Component({
  selector: 'dss-portal-core',
  imports: [SidebarComponent, RouterOutlet, PaymentPlansComponent, AutoHideScrollbarDirective],
  templateUrl: './portal-core.component.html',
  styleUrl: './portal-core.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(window:resize)': 'onResize()',
  },
})
export class PortalCoreComponent {
  readonly layoutService = inject(LayoutService);

  sidebarCollapseEvent() {
    this.layoutService.extendLayout.update((isLayoutExtended) => !isLayoutExtended);
  }

  sidebarCollapsePhoneEvent() {
    this.layoutService.isPhoneLayout.update((isPhoneLayout) => !isPhoneLayout);
  }

  onResize() {
    this.layoutService.screenWidth.set(window.innerWidth);
    this.layoutService.isPhoneLayout.set(this.layoutService.screenWidth() <= 976 && this.layoutService.extendLayout());
  }
}
